import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { schemaGroup } from "./schema";
import Notification from "../../../../components/toast";
import functions from "../../../../util/functions";
import reqComplementos from "../../../../services/reqMultiTenant/reqComplementos";

export const useGroupForm = (
	isOpen,
	handleClose,
	idGrupoToEdit,
	gruposMock,
	setGruposMock,
	setFilteredGrupos,
	grupoSelecionado,
	setGrupoSelecionado,
	fetchGrupos,
) => {
	const {
		register,
		handleSubmit,
		setValue,
		reset,
		watch,
		formState: { errors, isSubmitting },
	} = useForm({
		mode: "all",
		resolver: zodResolver(schemaGroup),
		defaultValues: {
			id_complementos_grupo: 0,
			descricao: "",
			obrigatorio: false,
			qtde_max_escolha: 0,
			ativo: true,
			ordem: 0,
			subitem: false,
		},
	});

	const [isLoadingForm, setIsLoadingForm] = useState(false);

	const isSubitem = watch("subitem");
	const isObrigatorio = watch("obrigatorio");

	// Força o campo 'obrigatorio' a ser true se 'subitem' for true
	useEffect(() => {
		if (isSubitem && !isObrigatorio) {
			setValue("obrigatorio", true, { shouldValidate: true });
		}
	}, [isSubitem, isObrigatorio, setValue]);

	useEffect(() => {
		const fetchData = async () => {
			if (isOpen) {
				if (idGrupoToEdit) {
					setIsLoadingForm(true);
					try {
						const response = await reqComplementos.buscarGrupo(idGrupoToEdit);

						const dataRaw = response?.data;
						// O backend pode retornar um array na busca por ID
						const grupo = Array.isArray(dataRaw) ? dataRaw[0] : dataRaw;

						if (grupo && typeof grupo === "object") {
							Object.keys(grupo).forEach((field) => {
								setValue(field, grupo[field] !== null ? grupo[field] : "", { shouldValidate: true });
							});
						}
					} catch (error) {
						Notification.showToast({
							message: "Erro ao buscar dados atualizados do grupo.",
							type: "error",
						});
						reset();
						handleClose();
					} finally {
						setIsLoadingForm(false);
					}
				} else {
					reset();
					setIsLoadingForm(false);
				}
			} else {
				reset();
				setIsLoadingForm(false);
			}
		};

		fetchData();
	}, [isOpen, idGrupoToEdit, reset, setValue]);

	const handleOnSubmit = async (data) => {
		try {
			const id_estabelecimento = functions.sessionIdEmpresa();

			const payload = {
				...data,
				qtde_max_escolha: Number(data.qtde_max_escolha) || 0,
				ordem: Number(data.ordem) || 0,
			};

			await reqComplementos.inserirGrupos(id_estabelecimento, [payload]);

			Notification.showToast({ message: "Grupo salvo com sucesso!", type: "success" });

			if (fetchGrupos) {
				await fetchGrupos();
			}

			handleClose();
		} catch (error) {
			const errorMsg = error.response?.data?.message || error.message || "Ocorreu um erro desconhecido";
			Notification.showToast({ message: "Erro ao salvar: " + errorMsg, type: "error" });
		}
	};

	return {
		register,
		handleSubmit,
		handleOnSubmit,
		errors,
		isSubmitting,
		isLoadingForm,
		watch,
	};
};
